import React from 'react';
import { Swiper, SwiperSlide} from 'swiper/react';
import { Navigation, Pagination, Scrollbar, Autoplay, Grid  } from "swiper";
import 'swiper/css';
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/grid";
import ItemProductoV2 from '../ItemProductoV2';
import useIsClient from '../../hooks/useIsClient';
import { Producto } from '../../models/Producto';

// `loop` deliberadamente NO es configurable por breakpoint acá: Swiper +
// loop + grid necesita que la cantidad de items sea múltiplo exacto de
// slidesPerView*rows, y ese chequeo (enableLoop, abajo) se hace una sola vez
// con los valores base. Si loop se pudiera pisar por breakpoint sin el mismo
// chequeo, Swiper crashea (classList of undefined) apenas la cuenta no da justa
// en el breakpoint activo — ya pasó una vez, por eso no está en este tipo.
type SwiperBreakpoints = Record<number, {
    slidesPerView?: number
    slidesPerGroup?: number
    spaceBetween?: number
    // Swiper solo pisa la config del módulo Grid si viene anidada como
    // `grid: { rows }` en el breakpoint — un `rows` de nivel superior no
    // hace nada (Swiper lo guarda como prop suelta y sigue leyendo
    // `params.grid.rows`, que queda fijo en el valor base para siempre).
    grid?: { rows?: number }
}>

type CarouselDeProductosV2Props = {
    data: Producto[]
    autoplay?: any
    spaceBetween?: number
    slidesPerView?: number
    slidesPerGroup?: number
    loop?: boolean
    navigation?: boolean
    pagination?: any
    scrollbar?: any
    rows?: number
    // Config de Swiper por ancho mínimo de viewport (mobile-first), reemplaza
    // el viejo patrón de "prop distinta según useMobileHook". El cálculo de
    // hasOverflow/enableLoop de abajo se hace con los valores base (el
    // breakpoint más chico), que es el caso más conservador para decidir si
    // hay overflow.
    breakpoints?: SwiperBreakpoints
}

const CarouselDeProductosV2 = (props: CarouselDeProductosV2Props)=>{

  // loop + breakpoints resuelve el breakpoint en cliente antes de que
  // termine la hidratación → mismatch. Se difiere el montaje al cliente
  // cuando hay breakpoints.
  const isClient = useIsClient();

  const productos = props.data || [];

  const columns = props.slidesPerView || 1;
  const rows = props.rows || 1;

  const totalVisible = columns * rows;
  const hasOverflow = productos.length > totalVisible;
  const slidesPerGroup =
    props.slidesPerGroup ?? columns;

  const enableLoop =
    props.loop &&
    productos.length >= totalVisible &&
    productos.length % totalVisible === 0;

  if (props.breakpoints && !isClient) return null;

  return(<>
    <Swiper
      key={`${columns}-${rows}`}
      modules={[Navigation, Pagination, Scrollbar, Autoplay, Grid]}
      autoplay={props.autoplay}
      spaceBetween={props.spaceBetween}
      slidesPerView={props.slidesPerView}
      slidesPerGroup={slidesPerGroup}
      loop={enableLoop}
      pagination={hasOverflow ? props.pagination : false}
      navigation={hasOverflow ? props.navigation : false}
      scrollbar={props.scrollbar}
      breakpoints={props.breakpoints}
      grid={{
        rows: props.rows ?? 1,
        fill: "row"
      }}
      // onSlideChange={() => console.log('slide change')}
      // onSwiper={(swiper) => console.log(swiper)}
      // style={{padding: "26px 0"}} // esto para el item levantado destacado...
    >
      {productos?.map((producto: Producto)=>(
        <SwiperSlide key={producto.id}>
          <ItemProductoV2 data={producto} isCarousel={true}/>
        </SwiperSlide>
      ))}
    </Swiper>
  </>);
};

export default CarouselDeProductosV2;
